import {ButtonPrimary} from '#/components/buttons/primary-button';
import {Content} from '#/components/welcome-modal/welcome-modal';
import {FunctionComponent, SVGProps} from 'react';

export const Step = ({
  title,
  description,
  onClick,
  src,
  contents,
  buttonLabel = 'Continue',
  RightIcon,
}: {
  title?: string;
  description: string;
  onClick: () => void;
  contents?: Content[];
  src: string;
  buttonLabel?: string;
  RightIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
}) => {
  return (
    <div className='flex flex-col items-center h-[95%]'>
      <div className='w-full grow overflow-hidden'>
        <img src={src} alt='welcome_image' className='w-full object-contain' />
      </div>
      <div className='p-4 md:p-6 flex flex-col items-center'>
        <div className='w-full text-center'>
          <h6 className='text-xl md:text-2xl font-bold'>{title}</h6>
          <p className='text-base md:text-lg text-gray-500 mt-2'>{description}</p>
        </div>
        <div className='flex flex-col md:flex-row justify-evenly w-full mt-6 md:mt-8 space-y-4 md:space-y-0 md:space-x-4'>
          {contents?.map(({Icon, header, sub}, index) => (
            <div key={index} className='flex flex-col items-center text-center w-full md:w-1/4'>
              {Icon}
              <p className='text-base md:text-lg font-bold mt-2'>{header}</p>
              {sub && <p className='text-sm md:text-base text-gray-500 break-words'>{sub}</p>}
            </div>
          ))}
        </div>
        <div className='flex justify-center mt-6 md:mt-8 mb-2 w-full'>
          <ButtonPrimary onClick={onClick}>
            {buttonLabel}
            {RightIcon && <RightIcon />}
          </ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export const NumberPad = ({num}: {num: number}) => (
  <div className='w-10 h-10 md:w-14 md:h-14 bg-blue-200 flex justify-center items-center rounded-2xl'>
    <p className='text-2xl md:text-4xl text-blue-700 font-extrabold'>{num}</p>
  </div>
);
